import { SVGAttributes } from 'react';
import styled from 'styled-components';
import {
  AGGREGATED_COUNT_BADGE_RADIUS,
  AGGREGATED_COUNT_LABEL_FONT_WEIGHT,
  AGGREGATED_COUNT_LABEL_SIZE,
} from './consts';
import { estimateCountLabelWidth } from './util/estimateCountLabelWidth';
import { colors } from '@ardoq/design-tokens';
import { classes } from '@ardoq/common-helpers';
import { NO_LINK_TARGET_DECORATION } from '../consts';

export const CountLabelElement = styled.g``;
const AggregatedEdgeLabel = styled.text<{ $isDiffState: boolean }>`
  font-size: ${AGGREGATED_COUNT_LABEL_SIZE}px;
  font-weight: ${AGGREGATED_COUNT_LABEL_FONT_WEIGHT};
  fill: ${props => (props.$isDiffState ? 'black' : colors.grey50)};
  dominant-baseline: central;
  text-anchor: middle;
  stroke: none;
`;
const AggregatedEdgeBackground = styled.rect`
  fill: ${colors.grey700};
`;

type CountLabelProperties = {
  count: number;
  diffCSSClass?: string;
} & SVGAttributes<SVGGElement>;
const CountLabel = ({ count, diffCSSClass, ...rest }: CountLabelProperties) => {
  const width = Math.max(
    estimateCountLabelWidth(count),
    2 * AGGREGATED_COUNT_BADGE_RADIUS
  );
  return (
    <CountLabelElement {...rest}>
      <AggregatedEdgeBackground
        x={-width / 2}
        width={width}
        height={2 * AGGREGATED_COUNT_BADGE_RADIUS}
        y={-AGGREGATED_COUNT_BADGE_RADIUS}
        rx={AGGREGATED_COUNT_BADGE_RADIUS}
        ry={AGGREGATED_COUNT_BADGE_RADIUS}
        className={classes(NO_LINK_TARGET_DECORATION, diffCSSClass)}
      />
      <AggregatedEdgeLabel $isDiffState={Boolean(diffCSSClass)}>
        {count}
      </AggregatedEdgeLabel>
    </CountLabelElement>
  );
};
export { CountLabel };
